import TrainerResult from "@components/Trainer/TrainerResult/TrainerResult";

export default TrainerResult;
